import { Button, Grid } from "@material-ui/core";
import { Formik } from "formik";
import React from "react";
import { object, string } from "yup";
import TextareaApp from "../../../components/TextareaApp";

export default function PayFormMed({ onSubmit, data, disabled = false }) {
    return (
        <Formik
            initialValues={{
                description: data?.Remark || "",
            }}
            validationSchema={object({
                description: string().required("Required."),
            })}
            onSubmit={onSubmit}>
            {({ values, handleChange, errors, handleSubmit }) => (
                <Grid container>
                    <Grid item xs={12} className="mb-3">
                        <TextareaApp
                            props={{
                                textAreaProps: {
                                    rows: 5,
                                    value: values?.description,
                                    id: "description",
                                    onChange: handleChange,
                                    disabled,
                                },
                            }}
                            errorMessage={errors?.description}
                        />
                    </Grid>
                    {!disabled && (
                        <Grid item xs={12}>
                            <div className="row justify-content-md-center">
                                <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                    <Button onClick={handleSubmit} type="submit" className="w-100 btn t-btn-primary">
                                        บันทึก
                                    </Button>
                                </div>
                            </div>
                        </Grid>
                    )}
                </Grid>
            )}
        </Formik>
    );
}
